import { LANG } from '../../constants/i18n';

export default {
    messages: {
        [LANG.SC]: {
            '投资者': '投资者',
        },
        [LANG.TC]: {
            "投资者": "投資者",
        },
        [LANG.EN]: {
            "投资者": "Investors",
        },
        [LANG.JA]: {
            "投资者": "投資家",
        }
    }
};